import { Component, input, Input} from '@angular/core';


@Component({
  selector: 'scroll-to-top',
  standalone: true,
  imports: [],
  templateUrl: './scroll-to-top.component.html',
  styleUrls: ['./scroll-to-top.component.scss'],
})
export class ScrollToTopComponent {
  @Input() scrollContainerRef?: HTMLElement;
  scrollHeight = input<number>(500)
  showScrollTop = false;

  private boundScrollHandler = this.onScroll.bind(this);

  ngAfterViewInit() {
    this.scrollContainerRef?.addEventListener('scroll', this.boundScrollHandler);
  }

  ngOnDestroy() {
    this.scrollContainerRef?.removeEventListener('scroll', this.boundScrollHandler);
  }

  private onScroll(): void {
    if (!this.scrollContainerRef) return;
    this.showScrollTop = this.scrollContainerRef.scrollTop > this.scrollHeight();
  }

  scrollToTop(): void {
    this.scrollContainerRef?.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
